import { type FC } from "react";
import { generatePath } from "react-router-dom";

import { Breadcrumb } from "@snapchat/snap-design-system";

import { AbsoluteRoute } from "../../../core/routes";
import { useSelectedOrganizationContainer } from "../../../shared/hooks";
import { LinkStyled } from "../../../shared/styles";

import { BreadcrumbItem, breadcrumbContainer } from "./DetailsBreadcrumb.styles";
import { LensBreadcrumb, LensesBreadcrumb } from "./messages.generated";

export const DetailsBreadcrumbsV3: FC = () => {
    const { orgId, lensFolderId } = useSelectedOrganizationContainer();

    return (
        <div className={breadcrumbContainer}>
            <Breadcrumb>
                <Breadcrumb.Item>
                    <LinkStyled
                        to={generatePath(AbsoluteRoute.ORG_LENS_FOLDER_LENSES, {
                            orgId: orgId ?? "",
                            lensFolderId: lensFolderId ?? "",
                        })}
                    >
                        <BreadcrumbItem>
                            <LensesBreadcrumb />
                        </BreadcrumbItem>
                    </LinkStyled>
                </Breadcrumb.Item>
                <Breadcrumb.Item>
                    <BreadcrumbItem active={true}>
                        <LensBreadcrumb />
                    </BreadcrumbItem>
                </Breadcrumb.Item>
            </Breadcrumb>
        </div>
    );
};
